// src/App.js
import { useEffect, useState } from 'react';
import '../App.css';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend'
import { DndProvider } from 'react-dnd';
import BallMatch from '../components/matchQuiz/BallMatch';
import BucketMatch from '../components/matchQuiz/BucketMatch';
import parse from 'html-react-parser';
import ModalInstruction from './ModalInstruction';
import { getText } from '../utils/languageUtils';

const MatchingQuiz = ({ language, isMarked, question, buckets, setBuckets, answerDragDrop }) => {
  const options = question?.options
  const answer = answerDragDrop?.marked_options
  const [ballData, setBallData] = useState(answer === null ? options : answer);
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    }
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension())
    }
    window.addEventListener('resize', updateDimension);


    return (() => {
      window.removeEventListener('resize', updateDimension);
    })
  }, [screenSize])

  const handleDrop = (draggedId, draggedQuisAnswer, ballIndex, bucketId) => {
    const droppedBall = ballData[ballIndex];

    // ✅ Correct matching condition
    const isCorrect = String(draggedQuisAnswer) === String(bucketId);

    if (isCorrect && !buckets.some((item) => item.id === droppedBall.id)) {
      setBuckets((prevBuckets) => [...prevBuckets, droppedBall]);
    }

    const updatedBalls = ballData.map((ball, index) => {
      if (index === ballIndex) {
        return {
          ...ball,
          wktStatus: true,
          ballStatus: isCorrect, // ✅ Only mark true if correctly matched
        };
      }
      return ball;
    });

    setBallData(updatedBalls);
  };


  return (
    <DndProvider backend={screenSize.width >= 921 ? HTML5Backend : TouchBackend}>
      <div id="body_bg" >
        <section className="my-3">
          <div className="container-fluid">
            <div className='justify-content-end d-flex' >
              <div onClick={handleShow}>
                <img src={require("../assets/images/instructions.png")} className='mobielViewIcon' />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="sectionsBox">
                  <p className="mb-0 text-center">{parse(getText(question?.title, language))}</p>
                </div>
              </div>
            </div>

            <div className="row  accotitle">
              <div className="col-12">
                <div className="contentbox mb-2 mt-3">
                  <div className="content_safty ">
                    <p className="mb-0">
                      {parse(getText(question.description, language))}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 mb-4" >
                <div style={{ display: "", justifyContent: 'center', alignItems: "center", }}>
                  {ballData?.map((ball, index) => (
                    <div className="questionBox mb-sm-0 mb-md-2" key={index}>
                      <div className="row align-items-center">
                        <div className="col-4 col-sm-3 col-md-3 col-lg-3" >
                          <BallMatch
                            key={ball.id}
                            id={String(ball.id)}
                            quisAnswer={ball.quisAnswer}
                            text={getText(ball.title, language)}
                            ballStatus={ball.ballStatus}
                          />
                        </div>
                        <div className="col-6 col-sm-8 col-md-8  col-lg-8">
                          <div className="content_question position-relative">
                            <p className="mb-0">{parse(getText(ball.info, language))}</p>
                          </div>

                        </div>
                        <div className='col-2 col-sm-1  col-md-1 col-lg-1'>
                          <div style={{ marginLeft: -25 }}>
                            <BucketMatch
                              bucketId={String(ball.quisAnswer)}
                              onDrop={(item) => handleDrop(item.id, item.quisAnswer, index, ball.quisAnswer)}
                            >
                              <div className='container bucket-size' style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                                {ball.quisAnswer}
                                {buckets.some(b => String(b.quisAnswer) === String(ball.quisAnswer))
                                  ? <img src={require(`../assets/images/dragdrop/match/dcp-gif${index}.gif`)} />
                                  : <img src={require("../assets/images/dragdrop/match/wt.png")} />
                                }
                              </div>
                            </BucketMatch>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <ModalInstruction show={show} handleClose={handleClose} inst={parse(getText(question.instruction, language))} />
          </div>
        </section>
      </div>
    </DndProvider>
  );
};

export default MatchingQuiz;
